import React, { useEffect } from "react";
import { transformTranslateFromValues } from "lib/helpers";
import { handleSuccessMessages } from "store/auth";
import { Field, Form, Formik } from "formik";
import { CkEditor, Loading } from "components/form";
import { useSetting } from "store/settings";

const General = (props) => {
  const {
    dispatch,
    getSetting,
    submitSetting,
    general,
    loading,
  } = useSetting();
  const key = "general";

  useEffect(() => {
    dispatch(getSetting(key));
  }, []);

  if (loading) {
    return (
      <div className="box p-5 flex justify-center">
        <Loading />
      </div>
    );
  }
  return (
    <>
      <Formik
        initialValues={general || {}}
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(
            submitSetting({ value: values, key }, () =>
              handleSuccessMessages("ویرایش اطلاعات انجام شد")
            )
          );
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty }) => (
          <Form>
            <div className="box rounded p-3">
              <h3>تنظیمات عمومی</h3>
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-2 gap-4">
                  <Field
                    placeholder="متن درباره ما"
                    label="متن درباره ما :"
                    name="about_us"
                    component={CkEditor}
                  />
                  <Field
                    placeholder="متن درباره ما انگلیسی"
                    label="متن درباره ما انگلیسی :"
                    name="en_about_us"
                    component={CkEditor}
                  />
                  <Field
                    placeholder="قوانین سایت"
                    label="قوانین سایت :"
                    name="site_rules"
                    component={CkEditor}
                  />
                  <Field
                    placeholder="قوانین سایت انگلیسی"
                    label="قوانین سایت انگلیسی :"
                    name="en_site_rules"
                    component={CkEditor}
                  />

                  <Field
                    placeholder="متن فروش بلیت اکران"
                    label="متن فروش بلیت اکران:"
                    name="ticket_sell_rule"
                    component={CkEditor}
                  />
                  <Field
                    placeholder="متن فروش بلیت اکران انگلیسی"
                    label="متن فروش بلیت اکران انگلیسی :"
                    name="en_ticket_sell_rule"
                    component={CkEditor}
                  />

                  <Field
                    placeholder="متن فروش بلیت اکران انگلیسی"
                    label="متن فروش بلیت اکران انگلیسی :"
                    name="en_ticket_sell_rule"
                    component={CkEditor}
                  />
                  <button
                    className="mt-4 btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default General;
